import React from 'react';

import css from './Type.module.css';

const Type = (props) => (
    <React.Fragment>
        <div className={css.TypeTitle}>
            {props.title}
        </div>
        <p className={css.TypeText}>
            {props.zoll} Zoll<br />
            Promjer cijevi: {props.mm} mm<br />
            {props.children}
            50 godina garancije
        </p>
    </React.Fragment>
);

export default Type;